/*global Tms*/

export function managePif() {

    const pifInfos = document.getElementById("pif-infos");

    if (pifInfos !== null) {
        const toggleables = Array.from(pifInfos.getElementsByClassName("pif-infos--collapse"));
        const toggleAllFn = function () {
            toggleables.forEach(function (element) {
                element.hidden = !element.hidden;
            });
        };

        pifInfos.querySelector("#pif-infos__collapse-button").addEventListener("click", toggleAllFn);
        pifInfos.querySelector("#pif-infos__expand-button").addEventListener("click", toggleAllFn);

        Tms.link(Object.assign({ nonInteraction: true }, JSON.parse(pifInfos.dataset.tms)));
    }
}
